/**
 * @ngdoc object
 * @name billing.positions
 * @description
 *
 */
angular
    .module('festzelt-os.billing.positions', [
        'ui.router',
        //'ngListView'
    ]);

require('./positions-routes');

// Controllers
require('./controllers/create-controller');
require('./controllers/edit-controller');
require('./controllers/list-controller');

// Factories
require('./factories/position-factory');



// WEBPACK FOOTER //
// ./src/app/pages/billing/positions/positions-module.js